import { RootState } from "../../../redux-store";

export const selectErrorToast = (state: RootState) => state.app.errorToast;
